module.exports = __webpack_public_path__ + "img/inspiration-ideaDAC.8ac18fe7.svg";